import { config } from '../../config';
import { MaxContactService } from '@gig/magic-messaging/dist/components/max-contact';

export const maxContact: MaxContactService | null = config.maxContact
    ? new MaxContactService(config.maxContact)
    : null;
